<!-- this shows if they're at a top level nav item -->
@if (isInMainNav) {
    <div
        class="main sidebar"
        [class.collapsed]="
            pageSidebarService.collapseEnabled() && isCollapsed()
        "
        [style.width]="sidebarWidth()"
    >
        <div class="sidebar-content" #sidebarContent>
            <ul
                class="d-md-block d-none p-0 m-0"
                #menuList
                [class.needs-scroll]="menuNeedsScroll()"
            >
                @for (parent of menuItems; track parent; let last = $last) {
                    @if (!parent.hideInMainView && parent.isVisible) {
                        <li
                            #menuItem
                            class="add-hover u"
                            [class.collapsed-item]="
                                pageSidebarService.collapseEnabled() &&
                                isCollapsed()
                            "
                            [class.active-link]="parent === currentParent"
                            [class.last-menu-item]="last"
                            [attr.data-text]="parent.text"
                            [matTooltip]="
                                pageSidebarService.collapseEnabled() &&
                                isCollapsed()
                                    ? parent.text
                                    : ''
                            "
                            [matTooltipPosition]="'right'"
                            (click)="doRouting(parent)"
                        >
                            @if (
                                pageSidebarService.collapseEnabled() &&
                                isCollapsed()
                            ) {
                                <!-- Collapsed view: icon only -->
                                <div class="collapsed-content">
                                    <i class="{{ parent.icon }}"></i>
                                </div>
                            } @else {
                                <!-- Expanded view: icon + text + chevron -->
                                <div class="expanded-content">
                                    <div class="menu-item-content">
                                        <i
                                            class="{{
                                                parent.icon
                                            }} me-3 d-inline-block"
                                        ></i>
                                        <span class="menu-text">{{
                                            parent.text
                                        }}</span>
                                    </div>
                                    @if (parent.children?.length) {
                                        <i
                                            class="bi bi-chevron-right chevron"
                                        ></i>
                                    }
                                </div>
                            }
                        </li>
                    }
                }
            </ul>

            <!-- Supers only (RF-2798): back to the redesigned nav -->
            @if (showNewNavToggle()) {
                <ng-container *ngTemplateOutlet="newNavToggle"></ng-container>
            }

            <!-- Promo box - only shows when it fits without causing scroll -->
            <!-- RF-1781 will add referral-card here -->
            @if (!isCollapsed() && showPromoBox()) {
                <div class="promo-content-box" #promoBox></div>
            }
        </div>

        <!-- Right-edge collapse handle -->
        @if (pageSidebarService.collapseEnabled()) {
            <div
                class="sidebar-edge-handle"
                (click)="toggleSidebar()"
                [matTooltip]="isCollapsed() ? 'Expand Menu' : 'Compact Menu'"
                [matTooltipPosition]="'right'"
            >
                <div class="handle-icon">
                    @if (isCollapsed()) {
                        <i class="bi bi-chevron-right"></i>
                    } @else {
                        <i class="bi bi-chevron-left"></i>
                    }
                </div>
            </div>
        }
    </div>
}

<!-- this shows if they've clicked to a child menu -->
@if (isInSubNav) {
    <div
        class="sub sidebar"
        [class.collapsed]="
            pageSidebarService.collapseEnabled() && isCollapsed()
        "
        [style.width]="sidebarWidth()"
    >
        <div class="sidebar-content" #sidebarContent>
            <ul
                class="d-md-block d-none p-0 m-0"
                #menuList
                [class.needs-scroll]="menuNeedsScroll()"
            >
                <li
                    class="text-primary mb-4 fw-bolder add-hover parent-title"
                    [class.collapsed-item]="
                        pageSidebarService.collapseEnabled() && isCollapsed()
                    "
                    [matTooltip]="
                        pageSidebarService.collapseEnabled() && isCollapsed()
                            ? 'Back to main menu'
                            : ''
                    "
                    [matTooltipPosition]="'right'"
                    (click)="goBackToMainNav()"
                    [attr.data-text]="currentParent?.text"
                >
                    @if (isCollapsed()) {
                        <!-- Collapsed: show back arrow only -->
                        <div class="collapsed-content">
                            <i class="bi bi-chevron-left"></i>
                        </div>
                    } @else {
                        <!-- Expanded: show back arrow and parent name -->
                        <div class="expanded-content">
                            <div class="menu-item-content">
                                <i
                                    class="bi bi-chevron-left me-3 d-inline-block"
                                ></i>
                                <span class="menu-text">{{
                                    currentParent?.text
                                }}</span>
                            </div>
                        </div>
                    }
                </li>

                <!-- list of child menu items -->
                @for (
                    item of currentParent?.children ?? [];
                    track item;
                    let last = $last
                ) {
                    @if (item.isVisible) {
                        <li
                            class="add-hover d-flex align-items-top"
                            [class.collapsed-item]="
                                pageSidebarService.collapseEnabled() &&
                                isCollapsed()
                            "
                            [class.last-menu-item]="last"
                            [routerLink]="item.route"
                            [class.sub-active-link]="item === currentItem"
                            [attr.data-text]="item.text"
                            [matTooltip]="
                                pageSidebarService.collapseEnabled() &&
                                isCollapsed()
                                    ? item.text
                                    : ''
                            "
                            [matTooltipPosition]="'right'"
                        >
                            @if (
                                pageSidebarService.collapseEnabled() &&
                                isCollapsed()
                            ) {
                                <!-- Collapsed: icon only -->
                                <div class="collapsed-content">
                                    @if (item.icon) {
                                        <i class="{{ item.icon }}"></i>
                                    }
                                </div>
                            } @else {
                                <!-- Expanded: icon + text -->
                                @if (item.icon) {
                                    <i
                                        class="me-3 d-inline-block {{
                                            item.icon
                                        }}"
                                    ></i>
                                }
                                <span class="menu-text">{{ item.text }}</span>
                            }
                        </li>
                    }
                }
            </ul>

            <!-- Supers only (RF-2798): back to the redesigned nav -->
            @if (showNewNavToggle()) {
                <ng-container *ngTemplateOutlet="newNavToggle"></ng-container>
            }

            <!-- Promo box - only shows when it fits without causing scroll -->
            <!-- RF-1781 will add referral-card here -->
            @if (!isCollapsed() && showPromoBox()) {
                <div class="promo-content-box" #promoBox></div>
            }
        </div>

        <!-- Right-edge collapse handle -->
        @if (pageSidebarService.collapseEnabled()) {
            <div
                class="sidebar-edge-handle"
                (click)="toggleSidebar()"
                [matTooltip]="isCollapsed() ? 'Expand Menu' : 'Compact Menu'"
                [matTooltipPosition]="'right'"
            >
                <div class="handle-icon">
                    @if (isCollapsed()) {
                        <i class="bi bi-chevron-right"></i>
                    } @else {
                        <i class="bi bi-chevron-left"></i>
                    }
                </div>
            </div>
        }
    </div>
}

<ng-template #newNavToggle>
    <div
        class="new-nav-toggle add-hover"
        [class.collapsed-item]="
            pageSidebarService.collapseEnabled() && isCollapsed()
        "
        [matTooltip]="isCollapsed() ? 'Try the new navigation' : ''"
        [matTooltipPosition]="'right'"
        (click)="switchToNewNav()"
    >
        <i class="bi bi-stars"></i>
        @if (!isCollapsed()) {
            <span class="ms-2">Try the new navigation</span>
        }
    </div>
</ng-template>
